import buildSubjectApiPath from '@Application/Subjects/buildSubjectApiPath';
import type * as React from 'react';
import transcriptExported, {
	type TranscriptExportedAction,
} from '@Application/Beneficiaries/Transcripts/Actions/transcriptExported';
import transcriptExportFailed, {
	type TranscriptExportFailedAction,
} from '@Application/Beneficiaries/Transcripts/Actions/transcriptExportFailed';
import type ExportTranscript from '@Application/Beneficiaries/Transcripts/Queries/ExportTranscript';
import { getFile } from '@Domain/Api';
import { downloadBlob } from '@Infra/Download';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';

type Actions = TranscriptExportedAction | TranscriptExportFailedAction;

export default (query: ExportTranscript) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const url = `${buildSubjectApiPath(query.facilityId, query.subject)}/interviews/${query.interviewId}/transcript/export?${query.toQueryString()}`;

			const { blob, filename } = await getFile(url);
			downloadBlob(blob, filename ?? 'transcript.txt');

			const action = transcriptExported();
			dispatch(action);
			return action;
		} catch (error) {
			const action = transcriptExportFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
